import classes from './style/work.module.css'
import Projects from '../data/Projects'
import Project from './Project'
import img from '../img/wave.svg'

const Work = () => {
  return (
    <div className={classes.Work}>
        <h1 className='title'>
        Portfolio
        </h1>
       <p className='subTitle color1'><span className='subTitleBefore'> /* </span> Projects I worked on <span className='subTitleAfter'> */ </span></p>
        <div className={classes.projectsContainer}>
          {
            Projects.map((pro)=> <Project project={pro} key={pro.id}/>)
          }
        </div>
        <div className='reverseWave'>
        <img src={img} alt="wave"/>
      </div>
    </div>
  )
}

export default Work
